import styled from 'styled-components';
import { getObjectWithSelector } from '../../../functions/objectFunctions/getObjectWithSelector';
import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import { useElements, useScene } from '../../../hooks';
import { LauncherElement } from '../../../types/launcherElement';
import { overflowOptions } from '../../../types/options';
import { VisibilityInput } from '../inputs/VisibilityInput';
import { SelectInput } from '../inputs/selectInput/SelectInput';

export const EffectsInputGroup = ({
  variant,
  tab,
  pseudoclass,

  colorPickerExtended,
  setColorPickerExtended,
}: {
  variant?: string;
  tab?: string;
  pseudoclass?: string;

  colorPickerExtended?: boolean;
  setColorPickerExtended?: (newValue: boolean) => void;
}) => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });

  let selector: string = 'props.class';
  if (variant && tab) {
    selector = `props.class.variants.${variant}.${tab}`;
  }

  if (pseudoclass === 'none') pseudoclass = undefined;
  if (pseudoclass) {
    selector = `${selector}.&:${pseudoclass}`;
  }

  const styleObj = getObjectWithSelector(selectedElement, selector);

  const labelWidth = 100;

  return (
    <Container>
      {tab === 'false' && <VisibilityInput {...{ variant, tab }} />}
      <SelectInput
        options={[
          { value: undefined, label: '' },
          { value: 'drag', label: 'Drag' },
          { value: 'no-drag', label: 'No Drag' },
        ]}
        id={`${lastSelectedElementID}-${variant}--webkit-app-region-${tab}-${pseudoclass}-input`}
        label="As Window Drag Handle"
        value={styleObj?.['-webkit-app-region' as any]}
        onChange={(inputValue: string) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.-webkit-app-region`]: inputValue,
            })
          )
        }
      />
      <SelectInput
        options={[
          { value: undefined, label: '' },
          { value: 'auto', label: 'Auto' },
          { value: 'none', label: 'None' },
        ]}
        id={`${lastSelectedElementID}-${variant}-pointerEvents-${tab}-${pseudoclass}-input`}
        label="Pointer Events"
        value={styleObj?.pointerEvents}
        onChange={(inputValue: string) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.pointerEvents`]: inputValue,
            })
          )
        }
      />
      <SelectInput
        options={[
          { value: undefined, label: '' },
          { value: 'auto', label: 'Auto' },
          { value: 'pointer', label: 'Pointer' },
          { value: 'wait', label: 'Wait' },
          { value: 'not-allowed', label: 'Not Allowed' },
          { value: 'grab', label: 'Grab' },
        ]}
        id={`${lastSelectedElementID}-${variant}-cursor-${tab}-${pseudoclass}-input`}
        label="Cursor"
        value={styleObj?.cursor}
        onChange={(inputValue: string) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.cursor`]: inputValue,
            })
          )
        }
      />
      <SelectInput
        options={overflowOptions}
        id={`${lastSelectedElementID}-${variant}-overflow-${tab}-${pseudoclass}-input`}
        label="Overflow"
        value={styleObj?.overflow}
        onChange={(inputValue: string) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.overflow`]: inputValue,
            })
          )
        }
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
